import AdminNavbar from "components/Navbar/Navbar";
import RequireAuth from "components/RequireAuth";
import Sidebar from "components/Sidebar/Sidebar";
import NotFound from "pages/NotFound/NotFound";
import React from "react";
import { Route, Routes } from "react-router-dom";
import userRoles from "utils/roles";
import { toggleContext } from "App";
import Profile from "pages/Profile/Profile";
import GrowthPlanAssessment from "pages/GrowthPlanAssessment/GrowthPlanAssessment";
import { consultantSidebarRoutes } from "data/sidebar";

function ConsultantLayout() {
  const [isopen, setisOpen] = React.useState(true);

  return (
    <>
      <toggleContext.Provider
        value={{
          isopen,
          setisOpen
        }}
      >
        <Sidebar routes={consultantSidebarRoutes} />
        <div className={isopen ? "sidecontainer" : "sidecontainerclose"}>
          <AdminNavbar />
          <div className="p-2">
            <Routes>
              <Route element={<RequireAuth allowedRoles={[userRoles.CONSULTANT]} />}>
                <Route path="profile" element={<Profile />} />
                <Route path="growth-plan-assessment" element={<GrowthPlanAssessment />} />
                <Route
                  path="/unauthorized"
                  element={
                    <NotFound
                      statusCode="403"
                      message="Sorry, you have no privilage to view this page."
                    />
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </div>
        </div>
      </toggleContext.Provider>
    </>
  );
}

export default ConsultantLayout;
